import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {PricesRegionLayout} from "../layout/PricesRegionLayout";

export const PricesFlatsView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);

    return <PricesRegionLayout type={PricesViewType.FLATS} region={region as IRegionReportPrice}></PricesRegionLayout>;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {PricesRegionLayout} from "../layout/PricesRegionLayout";

export const PricesFlatsView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);

    return <PricesRegionLayout type={PricesViewType.FLATS} region={region as IRegionReportPrice}></PricesRegionLayout>;
};
